const QUAN_LY_TAI_KHOAN = "/admin_chatbot"
const HOME = "/admin_chatbot"
const ROUTER = {
  SVG_VIEWER: "/svg-viewer",
  HOME: "/admin_chatbot",
  DANG_NHAP: `${HOME}/dang-nhap`,
  DANG_KY: `${HOME}/dang-ky`,
  DOI_MAT_KHAU: `${HOME}/doi-mat-khau`,
  ACCOUNT: `${HOME}/tai-khoan`,
  //ANONYMOUS
  PROCEDURE: '/procedure',

  // ADMIN
  QUAN_LY_TAI_KHOAN: "/quan-ly-tai-khoan",
  QUAN_LY_TAI_LIEU: `${HOME}/quan-ly-tai-lieu`,
  QUAN_LY_NGUOI_DUNG: `${HOME}/quan-ly-nguoi-dung`,
  QUAN_LY_AI: `${HOME}/quan-ly-AI`,
  CAI_DAT: `${HOME}/cai-dat`,
  CAP_NHAT_IDE: `${HOME}/cap-nhat-ide`,
  LICH_SU_CHAT: `${HOME}/lich-su-chat`,


}
export default ROUTER
